/* eslint-disable */
import React, { useState, useEffect }  from 'react';
import Modal from './modal/modal.component';
import Card from './card.component';
import { useForm } from "react-hook-form";
import {
  Row,
  Col,
  
} from 'react-bootstrap';
import detalleFunction from '../views/detalle/detalle.function';
import notification from './notification.component';
import utils from '../utils/utils.functions';
import CheckBoxCustom from './checkbox/CheckBoxCustom';


const GuiaExterna = ({ data, onUpdate, disabled = false }) => {

  const { register, handleSubmit, errors, reset } = useForm();
  const [show, setShow] = useState(false);
  const [list, setList] = useState([]);
  const [notificationx, setNotificationx] = useState(false);

  const onSubmit = (data) => {
    detalleFunction.externo({...data, notification: notificationx }).then((respuesta) => {
      if (respuesta.destinatario_actualizado) {
        notification.success();
        onUpdate();
        toggle();
       } else {
        notification.waring('La guia externa fue actualizada.');
       }
    });
  }
  
  useEffect(() => {
    if (show){
      getExternos();
    }
  },[show]);

  const toggle = () => {
    setShow(!show);
  }

  const getExternos = () => {
    utils.externos().then((respuesta) => {
      setList(respuesta.externoslist);
      reset({ 
        id: data.id,
        guide_assigned_courier: data.guide_assigned_courier,
        empresa_externa: data.empresa_externa_id,
      });
    })
  }

  return (
  <>
    <button 
      onClick={() => toggle() } 
      type="button" className="btnx btnx-warn" disabled={disabled}>
        Agregar guia externa
    </button>
    <Modal show={show}>
       <form onSubmit={handleSubmit(onSubmit)}>
      <Card>
        <Row>
          <Col lg={6}>
            <div>
              <small>Numero de guia externo</small>
              <div>
              <input type="text"
                className={`form-control input-border ${errors.guide_assigned_courier && "is-invalid"} mr-1`}
                name="guide_assigned_courier"
                placeholder="Ingrese guia externa"
                ref={register({ required: true })}
              />
              </div>
            </div>
          </Col>
          <Col lg={6}>
            <div>
              <small>Empresa</small>
              <div>
              <select 
                className={`form-control input-border ${errors.empresa_externa && "is-invalid"} mr-1`}
                name="empresa_externa"
                ref={register({ required: true, validate: value => value !== 'null' })}
              >
                <option value="null">Seleccione...</option>
                {list.map((e, idx) => {
                  return <option value={e.id} key={idx}>{e.nombre}</option>
                })}
              </select>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col lg={8}>
            <div style={{ marginTop: 12, display: 'flex', alignItems: 'center' }}>
              <CheckBoxCustom value={notificationx} onValue={() => setNotificationx(!notificationx)}/>
              <p>{' '}¿ Enviar notificación al cliente de su guia externa ?</p>
            </div>
          </Col>
        </Row>
        <Row>
          <Col className="d-flex justify-content-end mt-3">
            <input type="hidden" name="id" ref={register({ required: true })} />
            <button type="submit" className="btnx btnx-warn mr-2">Guardar</button>
            <button onClick={() => toggle()}  type="button" className="btnx btnx-warn">Cancelar</button>
          </Col>
        </Row>
      </Card>
       </form>
    </Modal>
  </>
  )
}

export default GuiaExterna;